import { Box, Button, Stack, Typography } from '@mui/material';
import './CatalogBanner.css';
import { Link } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export function CatalogBanner() {
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    if (isTablet) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px',
                    backgroundColor: '#05304F'
                }}
            >
                <Typography
                    variant="h5"
                    sx={{
                        lineHeight: '108%',
                        fontFamily: '"Noto Sans", Arial, sans-serif;',
                        color: 'rgb(255, 255, 255)',
                        fontSize: '32px',
                        fontWeight: '600',
                        textAlign: 'center',
                        textTransform: 'uppercase'
                    }}
                >
                    Каталог автошкол
                </Typography>
                <Typography
                    sx={{
                        fontFamily: '"Noto Sans", Arial, sans-serif;',
                        color: 'rgb(255, 255, 255)',
                        fontSize: '22px',
                        fontWeight: '500',
                        textAlign: 'center'
                    }}
                >
                    Подберите автошколу в своем городе
                </Typography>
                <Button
                    component={Link}
                    to={'/catalog'}
                    variant={'contained'}
                    sx={{
                        marginTop: '20px'
                    }}
                >
                    Посмотреть каталог
                </Button>
            </Box>
        );
    }

    return (
        <Stack
            flexDirection={'row'}
            className={'box_parent'}
        >
            <Box className={'box2'}>
                <Stack className={'inbox'}>
                    <Stack className={'inbox_top'}>
                        <Typography
                            sx={{
                                color: 'rgb(255, 255, 255)',
                                fontSize: '44px',
                                fontWeight: '600',
                                lineHeight: '120%',
                                textTransform: 'uppercase'
                            }}
                            variant="h5"
                        >
                            Каталог
                            {' '}
                            <br/>
                            {' '}
                            автошкол
                        </Typography>
                        <Typography
                            sx={{
                                color: 'rgb(255, 255, 255)',
                                fontSize: '22px',
                                fontWeight: '500'
                            }}
                        >
                            Подберите автошколу
                            {' '}
                            <br/>
                            {' '}
                            в своем городе
                        </Typography>
                    </Stack>
                    <Button
                        component={Link}
                        to={'/catalog'}
                        variant={'contained'}
                        sx={{
                            paddingInline: '46px',
                            paddingBlock: '24px',
                            alignSelf: 'flex-start',
                            fontFamily: 'Inter, Arial, sans-serif',
                        }}
                    >
                        Посмотреть каталог
                    </Button>
                </Stack>
            </Box>

            <Box className={'box3'}>
            </Box>

            <svg
                className="flt_svg"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs>
                    <filter id="flt_tag">
                        <feGaussianBlur
                            in="SourceGraphic"
                            stdDeviation="8"
                            result="blur"
                        />
                        <feColorMatrix
                            in="blur"
                            mode="matrix"
                            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                            result="flt_tag"
                        />
                        <feComposite
                            in="SourceGraphic"
                            in2="flt_tag"
                            operator="atop"
                        />
                    </filter>
                </defs>
            </svg>
        </Stack>
    );
}